import Immutable from 'immutable';
import { RouteAction, ROUTE_COURSE_PAGE } from '../routeActions';
import { routeIsInCourseWithQueryParam } from './CurrentCoursePath/constants';
import { USERPILOT_CHECKLIST_PARAMETER_NAME } from '../../web/containers/Userpilot/constants';

export const isModuleViewerChange = (
  location: RouteAction,
  action: RouteAction
): boolean => {
  const payloadsMatch = Immutable.is(
    Immutable.fromJS(location.params),
    Immutable.fromJS(action.params || {})
  );

  const queriesMatch = Immutable.is(
    Immutable.fromJS(location.query).delete('moduleSet'),
    Immutable.fromJS(action.query || {}).delete('moduleSet')
  );
  if (
    location.type === ROUTE_COURSE_PAGE &&
    action.type === ROUTE_COURSE_PAGE
  ) {
    const institutionsMatch =
      (!action.state.institutionPrefix && !location.state.institutionPrefix) ||
      action.state.institutionPrefix === location.state.institutionPrefix;

    return payloadsMatch && institutionsMatch && queriesMatch;
  } else if (
    location.type === action.type &&
    routeIsInCourseWithQueryParam(location)
  ) {
    return payloadsMatch && queriesMatch;
  }
  return false;
};

// Check if the only change is the userpilot checklist parameter
export const isUserpilotCheckListChange = (
  location: RouteAction,
  action: RouteAction
): boolean => {
  const payloadsMatch = Immutable.is(
    Immutable.fromJS(location.params),
    Immutable.fromJS(action.params || {})
  );

  const queriesMatch = Immutable.is(
    Immutable.fromJS(location.query).delete(USERPILOT_CHECKLIST_PARAMETER_NAME),
    Immutable.fromJS(action.query || {}).delete(
      USERPILOT_CHECKLIST_PARAMETER_NAME
    )
  );

  if (
    location.type === ROUTE_COURSE_PAGE &&
    action.type === ROUTE_COURSE_PAGE
  ) {
    const institutionsMatch =
      (!action.state.institutionPrefix && !location.state.institutionPrefix) ||
      action.state.institutionPrefix === location.state.institutionPrefix;

    return payloadsMatch && institutionsMatch && queriesMatch;
  } else if (
    location.type === action.type &&
    routeIsInCourseWithQueryParam(location)
  ) {
    return payloadsMatch && queriesMatch;
  }
  return false;
};

export const isWithinCourseEnvironment = (
  location: RouteAction,
  action: RouteAction
): boolean => {
  if (
    (location.type === ROUTE_COURSE_PAGE ||
      routeIsInCourseWithQueryParam(location)) &&
    (action.type === ROUTE_COURSE_PAGE || routeIsInCourseWithQueryParam(action))
  ) {
    const institutionsMatch =
      (!(action.state || {}).institutionPrefix &&
        !(location.state || {}).institutionPrefix) ||
      (action.state || {}).institutionPrefix ===
        (location.state || {}).institutionPrefix;

    const courseCodesMatch =
      (action.type === ROUTE_COURSE_PAGE
        ? action.params.courseCode
        : action.query.course) ===
      (location.type === ROUTE_COURSE_PAGE
        ? location.params.courseCode
        : location.query.course);

    if (institutionsMatch && courseCodesMatch) {
      return true;
    }
  }
  return false;
};

export const isPaginationQueryWithinSameContext = (
  location: RouteAction,
  action: RouteAction
): boolean => {
  if (
    routeIsInCourseWithQueryParam(location) &&
    routeIsInCourseWithQueryParam(action)
  ) {
    const queriesMatch = Immutable.is(
      Immutable.fromJS(location.query)
        .delete('cursor')
        .delete('pageSize')
        .delete('filter'),
      Immutable.fromJS(action.query)
        .delete('cursor')
        .delete('pageSize')
        .delete('filter')
    );
    // Currently we dont need to check params and instititionPrefix because the actions listed in routeIsInCourseWithQueryParam dont have those params and institution prefix.

    return queriesMatch;
  }

  return false;
};

export const isSameRoute = (
  action1: RouteAction,
  action2: RouteAction
): boolean => {
  if (action1.type !== action2.type) {
    return false;
  } else if (
    !Immutable.is(
      Immutable.fromJS(action1.params || {}).delete('institutionPrefix'),
      Immutable.fromJS(action2.params || {}).delete('institutionPrefix')
    )
  ) {
    // The institutionPrefix is not in the params on custom domains!
    return false;
  } else if (
    !Immutable.is(
      Immutable.fromJS(action1.query || {}),
      Immutable.fromJS(action2.query || {})
    )
  ) {
    return false;
  }
  return true;
};
